import {Pipe, PipeTransform} from "@angular/core";
import {isValidLink} from "../validators/video.validators";

@Pipe({
  name: 'videoframePipe',
  standalone:true
})
export class VideoFramePipe implements PipeTransform {
  transform(url:any): any {
    const obj = isValidLink(url);
    if(obj.status){
      if(obj.origin === 'YOUTUBE'){
        if(obj.videoType.includes('shorts')){
          return  `<iframe width="315" style="max-width:100%" height="560" src="https://www.youtube.com/embed/${obj.id}" title="YouTube" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>`
        } else{
          return  `<iframe width="560" style="max-width:100%" height="315" src="https://www.youtube.com/embed/${obj.id}" title="YouTube" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>`
        }
      }
      else if(obj.origin === 'RUTUBE'){
        const pswrd = obj.password == null || obj.password.length < 1 ? '' : `?p=${obj.password }` ;
        return  `<iframe width="560" style="max-width:100%" height="315" src="https://rutube.ru/play/embed/${obj.id}${pswrd}" title="RUTUBE" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>`
      }
      else if(obj.origin === 'VK_VIDEO'){
        const oid = obj.id.split('_').at(0)
        const id = obj.id.split('_').at(-1)
        if(obj.videoType === 'clip'){
          return  `<iframe src="https://vkvideo.ru/clip_ext.php?oid=${oid}&id=${id}&autoplay=1" width="325" style="max-width:100%;background-color:#000" height="646" allow="autoplay; encrypted-media; fullscreen; picture-in-picture; screen-wake-lock;" frameborder="0" allowfullscreen></iframe>`
        }
        return  `<iframe src="https://vkvideo.ru/video_ext.php?oid=${oid}&id=${id}" width="560" style="max-width:100%" height="315" allow="autoplay; encrypted-media; fullscreen; picture-in-picture; screen-wake-lock;" frameborder="0" allowfullscreen></iframe>`
      }
      return `<p style="color:red">Неверный формат видео</p>`
    }
    return `<p style="color:red">Неверный формат видео</p>`
  }
}
